// Check if running in Vite dev server (hot reload) - use localhost
let domainPort: string;
let protocol: string;
let buildEnv: string;

if (typeof import.meta.hot !== "undefined") {
    // Local development with Vite
    domainPort = "localhost:5009";
    protocol = "http://";
    buildEnv = "local";
} else if (typeof window !== "undefined") {
    // Runtime detection based on current domain
    const hostname = window.location.hostname;
    
    if (hostname === "dev.issen.com" || hostname === "static.dev.issen.com") {
        domainPort = "api.dev.issen.com";
        protocol = "https://";
        buildEnv = "docker";
    } else if (hostname === "app.issen.com" || hostname === "static.app.issen.com") {
        domainPort = "api.app.issen.com";
        protocol = "https://";
        buildEnv = "docker";
    } else if (hostname.includes("localhost")) {
        domainPort = "localhost:5009";
        protocol = "http://";
        buildEnv = "local";
    } else {
        // Default fallback to production
        domainPort = "api.app.issen.com";
        protocol = "https://";
        buildEnv = "docker";
    }
} else {
    // SSR/Build time fallback
    domainPort = "api.app.issen.com";
    protocol = "https://";
    buildEnv = "docker";
}

export { domainPort, protocol, buildEnv };
